/**
 * Based on the asset URL, return which CMS it came from
 */

export const getImageSource = (url: string) => {
  if (
    url.startsWith("https://images.ctfassets.net/") ||
    url.startsWith("https://videos.ctfassets.net/")
  ) {
    return "contentful" as const;
  } else if (url.startsWith("https://img.redbull.com/")) {
    return "crepo" as const;
  } else if (url.startsWith("https://a.storyblok.com/")) {
    return "storyblok" as const;
  } else {
    return "fallback" as const;
  }
};
